import React, { createContext, useReducer, useContext } from "react";
import app from "../api/realm";

const AuthDispatchContext = createContext();
const AuthStateContext = createContext();

// Build a consistent user shape from the Realm current user + customData
const buildUser = (realmUser) => {
  if (!realmUser || !realmUser.isLoggedIn) return null;
  const custom = realmUser.customData || {};
  return {
    userId: custom.email || realmUser.profile?.email || "",
    subscriptionType: custom.subscriptionType || "limited",
    fullName: custom.fullName || "",
    token: "realm", // kept for compatibility — Realm manages tokens internally
    refresh: null,
  };
};

const user = buildUser(app.currentUser);

const authReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      return { ...state, user: action.payload };
    case "LOGOUT":
      return { ...state, user: null };
    default:
      throw new Error(`Unknown action type: ${action.type}`);
  }
};

export function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(authReducer, { user });

  return (
    <AuthDispatchContext.Provider value={dispatch}>
      <AuthStateContext.Provider value={state}>{children}</AuthStateContext.Provider>
    </AuthDispatchContext.Provider>
  );
}

export const useAuthState = () => useContext(AuthStateContext);
export const useAuthDispatch = () => useContext(AuthDispatchContext);
